import React from 'react';
import { SvgIcon } from '~/lib/bn-material-ui';

export function FileDocumentImported(props) {
  return (
    <SvgIcon viewBox='0 0 16 16' {...props}>
      <path
        d='M4.00002 1.33334C3.26002 1.33334 2.66669 1.92668 2.66669 2.66668V13.3333C2.66669 14.0733 3.26002 14.6667 4.00002 14.6667H9.20669C8.85335 14.06 8.66669 13.3667 8.66669 12.6667C8.66669 12.4467 8.68669 12.22 8.72002 12H4.00002V10.6667H9.20669C9.51335 10.1333 9.94002 9.66668 10.4534 9.33334H4.00002V8.00001H12V8.72001C12.22 8.68668 12.4467 8.66668 12.6667 8.66668C12.8934 8.66668 13.1134 8.68668 13.3334 8.72001V5.33334L9.33335 1.33334M8.66669 2.33334L12.3334 6.00001H8.66669V2.33334Z'
        fill='currentColor'/>
      <path d='M14.2 12.7368L12.1 14.7895L10 12.7368L11.4 12.7368L11.4 10L12.8 10L12.8 12.7368L14.2 12.7368Z'
        fill='currentColor'/>
    </SvgIcon>
  );
}
